/**
 * @file 风险提示弹窗
 */
import { useRef } from 'react';
import { Button } from '@bfe/moly';
import { useFm } from '@web3/base-hooks';
import { useParams } from 'react-router-dom';
import { Modal } from '@web3/base-components';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import styles from './index.module.scss';

// 加载 UTC 插件
dayjs.extend(utc);

interface Props {
  show: boolean;
  onConfirm: (v: boolean) => void;
  onClose: () => void;
}

export const DelayDrawModal = (props: Props) => {
  const { show, onConfirm, onClose } = props;
  const fm = useFm();
  const checkedRef = useRef(false);
  // 获取当前 UTC 时间
  const nowUTC = dayjs.utc();

  // 获取第二天的 UTC 时间
  const nextDayUTC = nowUTC.add(1, 'day');

  // 格式化为日期字符串
  const nextDayUTCFormatted = nextDayUTC.format('YYYY.MM.DD');

  return (
    <Modal
      open={show}
      onCancel={onClose}
      title={null}
      size="medium"
      footer={null}
    >
      <div className={styles.title}>{fm('joinSuccess')}</div>
      <div className={styles.desc}>
        {fm('successfulParticipation', {
          num: nextDayUTCFormatted,
        })}
      </div>
      <div className={styles.buttonArea}>
        <Button
          variant="primary"
          className={styles.button}
          onClick={() => {
            onClose();
            onConfirm(checkedRef.current);
          }}
        >
          {fm('i_know')}
        </Button>
      </div>
    </Modal>
  );
};
